import { type StyleProp, StyleSheet, type ViewStyle } from 'react-native';
import { theme } from '@garnish/constants';

// ─── Types ───────────────────────────────────────────────────────────────────

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const RadioSizes = {
  sm: 'sm',
  md: 'md',
};

export type RadioSize = keyof typeof RadioSizes;

// ─── Styles ──────────────────────────────────────────────────────────────────

export const sizeStyles: Record<
  RadioSize,
  StyleProp<ViewStyle>
> = StyleSheet.create({
  sm: {
    minHeight: theme.spacing['10'],
    padding: theme.spacing['2'],
    borderRadius: theme.radius.medium,
  },
  md: {
    minHeight: theme.spacing['18'],
  },
});
